<script setup lang="ts">
import KDMCellSlider from "@/kdm/KDMCellSlider.vue";
import {computed} from "vue";
import {SliderUpdate} from "#/KdmNode";

const props = defineProps<{
  cellId: string,
  cellIndicatorsMapping: Record<string, Map<string, {title: string, moderation_class: string, href: string, is_in_kik: boolean}>>,
  isLocked?: boolean
}>();

const emit = defineEmits<{
  update: [value: SliderUpdate]
  delete: [value: string]
}>()

const hasIndicators = computed(() => Object.keys(props.cellIndicatorsMapping).includes(props.cellId))

function bubbleUpRemove(indicatorId: string): void {
  emit('delete', indicatorId)
}

function bubbleUpUpdate(data: SliderUpdate): void {
  emit('update', data)
}

</script>

<template>
  <div class="kdm__cell-indicators-list">
    <template v-if="hasIndicators">
      <div v-for="([id, info],i) in cellIndicatorsMapping[cellId]"
           class="kdm__indicator-wrapper"
           :key="`${cellId}-${id}`">
        <KDMCellSlider
          :label="info.title"
          :moderation-class="info.moderation_class"
          :href="info.href"
          :is-in-kik="info.is_in_kik"
          :cell-id="cellId"
          :indicator-id="id"
          :index="i"
          :is-locked="isLocked"
          @update="bubbleUpUpdate"
          @delete="bubbleUpRemove"
        />
      </div>
    </template>
  </div>
</template>

<style scoped>
.kdm__cell-indicators-list {
  padding-bottom: 5px;
}
</style>